import { Flex, FlexProps } from 'component-library/components/layout/Flex';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import React, { FC } from 'react';

const currentYear = new Date().getFullYear();

const faqs = [
  {
    title: 'What tips should I know before retiring?',
    to: '/advice/retirement/20-retirement-tips-for-a-happy-retirement',
  },
  {
    title: `What's the average retirement income for ${currentYear}?`,
    to: '/advice/lifestyle/average-retirement-income-how-do-you-compare',
  },
  {
    title: 'How can I retire without savings?',
    to: '/advice/lifestyle/how-to-retire-without-savings',
  },
  {
    title: 'Will my retirement income be enough?',
    to: '/advice/retirement-accounts/will-your-retirement-income-be-enough',
  },
  {
    title: 'How long will $100,000 last me in retirement?',
    to: '/advice/retirement-accounts/how-long-will-100,000-last-in-retirement',
  },
];

export const FAQs: FC<FlexProps> = ({ ...rest }) => (
  <Flex {...rest} column>
    <Body variant={1} medium marginBottom={24}>
      FAQs
    </Body>
    {faqs.map((faq, idx) => (
      <Link key={idx} variant={3} marginBottom={12} to={faq.to}>
        {faq.title}
      </Link>
    ))}
  </Flex>
);
